import { createAppWrap } from '../../create_app_wrap';
import setupMixin from './mixin';

// カテゴリチェック数範囲
const CATEGORY_CHECK_COUNT_BETWEEN = {
    MIN: 1,
    MAX: 3
};
// 非表示カテゴリの値
const HIDDEN_CATEGORY_VALUES = [13, 14, 15, 16, 17, 18, 19, 20 ,21];

const view = '[data-view="setup-store"]';
const init = () => {
    /**

     * Vueオブジェクト
     * @type {Vue|any}
     */
    createAppWrap({
        el: view,
        /**
         * データ群
         */
        data() {
            return {
                // 非表示カテゴリの表示フラグ
                show_more_categories: false,
                // 各必須項目のバリデーションフラグ(すべてtrueで次へ進める)
                valid_flags: {
                    store_categories: false
                }
            };
        },
        /**
         * ミックスインオブジェクト
         */
        mixins: [
            setupMixin
        ],
        /**
         * 描画後に実行される処理
         */
        mounted: function () {
            // 非表示カテゴリを選択していたら予め開いておく
            this.shouldShowMoreCategories();
            // カテゴリチェック数バリデーション
            this.updateValidStoreCategories();
        },
        /**
         * 監視プロパティ
         */
        watch: {
            // カテゴリチェック数が変化したら都度バリデーション
            ['setup_data.shopInfo.store_categories']: function (NewValue, oldValue) {
                this.updateValidStoreCategories();
                // 最大値超えはアラート表示して、チェックを戻す
                if (!this.valid_flags.store_categories && this.storeCategories.length != 0) {
                    swal('カテゴリの選択数は' + CATEGORY_CHECK_COUNT_BETWEEN.MAX + 'つまでです。');
                    this.$nextTick(() => (this.setup_data.shopInfo.store_categories = oldValue));
                }
            },
        },
        /**
         * 算出プロパティ
         */
        computed: {
            // カテゴリの選択
            storeCategories: {
                // jsonデコード
                get: function () {
                    if (typeof this.setup_data.shopInfo.store_categories !== 'undefined') {
                        return JSON.parse(this.setup_data.shopInfo.store_categories);
                    };
                    return [];
                },
                // jsonエンコード
                set: function (newValue) {
                    // ソート
                    newValue.sort((a, b) => {return a - b;});
                    this.setup_data.shopInfo.store_categories = JSON.stringify(newValue);
                }
            }
        },
        /**
         * 各種メソッド
         */
        methods: {
            // カテゴリチェック数が適正範囲か
            updateValidStoreCategories: function () {
                const count = this.storeCategories.length;
                if (count < CATEGORY_CHECK_COUNT_BETWEEN.MIN || count > CATEGORY_CHECK_COUNT_BETWEEN.MAX) {
                    this.valid_flags.store_categories = false;
                } else {
                    this.valid_flags.store_categories = true;
                }
            },
            // 非表示カテゴリをすでに選択されていたら開いておく
            shouldShowMoreCategories: function () {
                const diff = HIDDEN_CATEGORY_VALUES.filter(i => this.storeCategories.indexOf(i) == -1);
                if (diff.length != HIDDEN_CATEGORY_VALUES.length) {
                    this.show_more_categories = true;
                }
            }
        },
    });
};

if (document.querySelector(view)) {
    init();
}
